import './MainMenu/items';
import { isOnderdeelBeschikbaar } from '@auth/marktsegmentBeschikbaarheid';
import { MenuItemRegistry } from './MainMenu/menuRegistry';
import { type EnvironmentSettings, type MenuItem } from './types';

export type { EnvironmentSettings, MenuItem };

export function createMenuItems(settings: EnvironmentSettings): MenuItem[] {
  return MenuItemRegistry.getAll()
    .filter(
      (definition) =>
        definition.isVisible(settings) &&
        isOnderdeelBeschikbaar(definition.onderdeel, settings.marktsegment),
    )
    .map((definition) => definition.create(settings));
}
